module.exports = "<app-t-topics></app-t-topics>\n"